import { PageConfig } from '../page-configs'
import { AlertId, getAlert } from '../alert'
import { DISCLAIMER, DISCLAIMER_UA } from '../../../global/variables'
import { getWelcomeText } from '../welcome'
import { FORM_DE_BUTTONS, FORM_UA_BUTTONS, FORMULAR_DE_BUTTONS, FORMULAR_UA_BUTTONS } from '../../feature-buttons'

export const pageConfigFormDE: PageConfig = {
    header: 'Digitaler Assistent',
    alert: getAlert(AlertId.FormBotDE),
    welcome: {
        text: getWelcomeText('FORM', 'MAIN_DE'),
        info: 'Für Fragen zu Geldleistungen wie Arbeitslosengeld oder Kindergeld klicken Sie bitte auf “Fragen zu anderen Themen stellen”!',
        disclaimer: DISCLAIMER,
        buttons: FORM_DE_BUTTONS,
    },
}

export const pageConfigFormUA: PageConfig = {
    header: 'Цифровий асистент',
    alert: getAlert(AlertId.FormBotUA),
    welcome: {
        text: getWelcomeText('FORM', 'MAIN_UA'),
        info: 'Для питань щодо грошових виплат, наприклад допомога по безробіттю або допомога на дитину, тисніть «Питання про інші теми»! Наразі ця інформація доступна лише доступна німецькою мовою.”!',
        disclaimer: DISCLAIMER_UA,
        buttons: FORM_UA_BUTTONS,
    },
}

export const pageConfigFormularDE: PageConfig = {
    header: 'Digitaler Assistent',
    alert: getAlert(AlertId.FormBotDE),
    welcome: {
        text: getWelcomeText('FORM', 'FORM_DE'),
        disclaimer: DISCLAIMER,
        buttons: FORMULAR_DE_BUTTONS,
    },
}

export const pageConfigFormularUA: PageConfig = {
    header: 'Цифровий асистент',
    alert: getAlert(AlertId.FormBotUA),
    welcome: {
        text: getWelcomeText('FORM', 'FORM_UA'),
        disclaimer: DISCLAIMER_UA,
        buttons: FORMULAR_UA_BUTTONS,
    },
}
